import { isVueAppInDOM, renderApp } from '@/src/shared/component-utilities';

import VideoPlayer from './VideoPlayer.vue';

export function load() {
  const selector = 'zel-video-player';

  if (!isVueAppInDOM(selector)) {
    return;
  }

  renderApp(VideoPlayer, selector);
}
